import React, { useEffect, useState } from 'react';

import { getCookie } from '../utils/cookie_utils';
import { buildPath } from '../utils/route_utils';
import { getConsent, setConsent, trackPageView } from '../utils/analytics';
import '../css/CookieConsent.css';

const TEXT = {
  message: {
    zh: '我們使用 Cookie 來分析網站流量並改善您的瀏覽體驗。您可以接受或拒絕分析用 Cookie。',
    en: 'We use cookies to analyze site traffic and improve your experience. You can accept or decline analytics cookies.',
    ja: '当サイトではトラフィック分析と体験向上のために Cookie を使用します。分析用 Cookie の使用を許可または拒否できます。',
  },
  accept: { zh: '接受', en: 'Accept', ja: '同意する' },
  decline: { zh: '拒絕', en: 'Decline', ja: '拒否する' },
  learnMore: { zh: '了解更多', en: 'Learn more', ja: '詳細' },
};

function resolveLang() {
  const c = getCookie('lang');
  if (c === 'en' || c === 'zh' || c === 'ja') return c;
  const seg = (typeof window !== 'undefined' ? window.location.pathname : '/')
    .split('/')[1] || '';
  if (seg === 'en') return 'en';
  if (seg === 'ja') return 'ja';
  return 'zh';
}

/**
 * Lightweight, GDPR-style consent banner. Shows only until the visitor
 * makes a choice; gates GA4 (analytics stay off until "Accept").
 */
export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const lang = resolveLang();

  useEffect(() => {
    // Show only when the visitor hasn't decided yet.
    if (!getConsent()) setVisible(true);
  }, []);

  const accept = () => {
    setConsent(true);                 // persists choice + boots GA4
    trackPageView(window.location.pathname + window.location.search); // first view
    setVisible(false);
  };

  const decline = () => {
    setConsent(false);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent" role="dialog" aria-live="polite" aria-label="Cookie consent">
      <p className="cookie-consent__text">
        {TEXT.message[lang]}{' '}
        <a className="cookie-consent__link" href={buildPath(lang, '/about/security_policy')}>
          {TEXT.learnMore[lang]}
        </a>
      </p>
      <div className="cookie-consent__actions">
        <button className="cookie-consent__btn cookie-consent__btn--ghost" onClick={decline}>
          {TEXT.decline[lang]}
        </button>
        <button className="cookie-consent__btn cookie-consent__btn--accept" onClick={accept}>
          {TEXT.accept[lang]}
        </button>
      </div>
    </div>
  );
}
